module.exports = __webpack_public_path__ + "files/8832c263c3b832ff0a93b18f9c4776cc.png";